export default [
  {
    path: '/app/corporate-policies-categories',
    name: 'CorporatePoliciesCategories',
    component: () => import('@/views/Admin/Corporate_policies_categories/Index.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES_CATEGORIES',
      action: 'read',
    },
  },
  {
    path: '/app/corporate-policies-categories/add',
    name: 'CorporatePoliciesCategoriesAdd',
    component: () => import('@/views/Admin/Corporate_policies_categories/Add.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/corporate-policies-categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES_CATEGORIES',
      action: 'read',
    },
  },
  {
    path: '/app/corporate-policies-categories/edit/:id',
    name: 'CorporatePoliciesCategoriesEdit',
    component: () => import('@/views/Admin/Corporate_policies_categories/Edit.vue'),
    meta: {
      pageTitle: 'Kurumsal Sosyal Sorumluluk Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/corporate-policies-categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_CORPORATE_POLICIES_CATEGORIES',
      action: 'read',
    },
  },
]
